//mileage scroll directive main function
var transportationOptionsScrollController = function ($scope, $element, $attrs) {
    var items = [];
    //addItem
    //
    //@param {Object} item to add
    //  - width - width of the slider item
    //  - height - height of the slider item  
    //
    //@description
    //Adds item into storage of items to calculate size of the crollable content
    $scope.addItem = function (item) {
        items.push(item);
    };

    function scrollToOption(data) {
        //calculate the position that is required to scroll to
        var offset = 0;
        for (var i = 0; i < items.length; i++) {
            if (items[i].index == data.index) {
                // calculating requred offset to scroll the container
                offset = (i == 0 ? 0 : (items[i].element.offsetLeft - (items[i].element.offsetLeft - items[i - 1].element.offsetLeft)));
                break;
            }
        };
        //scroll the container
        angular.element($element)[0].scrollLeft = offset;
    };

    $scope.scrollOnSelect = function (el) {
        //calculate the position that is required to scroll to
        var wrapper = angular.element($element)[0];
        var scrollPos = wrapper.scrollLeft;
        var wrapperRightOffset = scrollPos + wrapper.clientWidth;
        var elOffset = el.offsetLeft;
        var elRightOffset = elOffset + el.clientWidth;

        if (elOffset < scrollPos) {
            //wrapper.scrollLeft = elOffset;
            $element.duScrollLeftAnimated(elOffset);
        } else if (elRightOffset > wrapperRightOffset) {
            //wrapper.scrollLeft = elRightOffset - wrapper.clientWidth;
            $element.duScrollLeftAnimated(elRightOffset - wrapper.clientWidth);
        }

    };

    //lesten to scroll event from parent scope
    $scope.$on('transportationOptionsScroll:scroll', function (event, data) {
        setTimeout(function () {
            scrollToOption(data);
        })
    });

};
//mileage scroll main function injections
transportationOptionsScrollController.$inject = ['$scope', '$element', '$attrs'];

angular.module('OSS').directive('transportationOptionsScroll', function () {
    return {
        restrict: 'A',
        controller: transportationOptionsScrollController
    }
});

//mileage scroll item directive main function
var transportationOptionsScrollItemController = function ($scope, $element, $attrs, $rootScope) {
    var currentElement = $element[0] ? $element[0] : undefined;
    if (currentElement) {
        //add information about item size into internal storeage of the parent controller
        var item = {
            index: $scope.$index,
            element: currentElement,
        };
        $scope.addItem(item);
        if ($scope.$last && $scope.transportationOptions && $scope.selectedTransportationOption) {
            var selectedTransportationOption = $scope.transportationOptions.filter(function (el) {
                return el.code == $scope.selectedTransportationOption.code;
            });

            if (selectedTransportationOption.length) {
                // send event to scroll container to selected TO
                $rootScope.$broadcast('transportationOptionsScroll:scroll', selectedTransportationOption[0]);
            }
        };
    };

    $scope.onSelectTransportationOption = function (transportationOption) {
        $scope.scrollOnSelect(currentElement);
        $scope.selectTransportationOption(transportationOption);
    }
};

//mileage scroll item function injections   
transportationOptionsScrollItemController.$inject = ['$scope', '$element', '$attrs', '$rootScope'];

module.exports = function () {
    return {
        restrict: 'A',
        controller: transportationOptionsScrollItemController
    }
}